<template>
  <j-modal
    :title="title"
    width="60%"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    :body-style="{ height: '580px', overflow: 'hidden', overflowY: 'scroll' }"
    @cancel="handleCancel"
    @ok="handleOk"
    :okText="$t('确定')"
    :cancelText="$t('关闭')"
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
  >
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="!disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="24">
              <a-descriptions :title="$t('问题详情')">
                <a-descriptions-item :label="$t('上报人')">{{ model.informant }}</a-descriptions-item>
                <a-descriptions-item :label="$t('上报人电话')">{{ model.informantPhone }}</a-descriptions-item>
                <a-descriptions-item :label="$t('现场坐标')">{{ model.coordinate }}</a-descriptions-item>
                <a-descriptions-item :label="$t('问题等级')">{{
                    filterDictTextByCache('problemLevel',model.problemLevel)
                  }}</a-descriptions-item>
                <a-descriptions-item :label="$t('设备编号')">{{ model.deviceNum }}</a-descriptions-item>
                <a-descriptions-item :label="$t('设备名称')">{{ model.deviceName }}</a-descriptions-item>
                <a-descriptions-item :label="$t('设备类型')">{{
                  filterDictTextByCache('deviceType', model.deviceType)
                }}</a-descriptions-item>
                <a-descriptions-item :label="$t('创建时间')">{{ model.createTime }}</a-descriptions-item>
              </a-descriptions>
              <a-descriptions :column="1">
                <a-descriptions-item :label="$t('问题描述')">{{ model.exceptionDescription }}</a-descriptions-item>
                <a-descriptions-item :label="$t('处理前图片或视频')"></a-descriptions-item>
              </a-descriptions>
              <div class="img-list">
                <div
                  class="img-box"
                  v-for="(item, index) in model.inspectionTaksRouteDeviceFilePaths"
                  :key="index"
                  @click="viewPicture(item)"
                  v-if="item.type==1"
                >
                  <div v-if="item.type==1">
                    <img :src="item.url" alt="" v-if="item.fileType == 'image'" />
                    <video controls :src="item.url" alt="" v-if="item.fileType == 'video'"></video>
                  </div>
                </div>
              </div>
              <a-descriptions :column="1" v-if="model.whetherToSolve==1">
                <a-descriptions-item :label="$t('处理后图片或视频')"></a-descriptions-item>
              </a-descriptions>
              <div class="img-list" v-if="model.whetherToSolve==1">
                <div
                  class="img-box"
                  v-for="(item, index) in model.inspectionTaksRouteDeviceFilePaths"
                  :key="index"
                  @click="viewPicture(item)"
                  v-if="item.type==2"
                >
                  <div v-if="item.type==2">
                    <img :src="item.url" alt="" v-if="item.fileType == 'image'" />
                    <video controls :src="item.url" alt="" v-if="item.fileType == 'video'"></video>
                  </div>
                </div>
              </div>
              <a-descriptions :column="2">
                <a-descriptions-item :label="$t('是否现场已解决')">
                  <a-tag :color="model.whetherToSolve==1?'green':model.whetherToSolve==2?'red':''">
                    {{ model.whetherToSolve==1?$t('已解决'):model.whetherToSolve==2?$t('未解决'):'' }}
                  </a-tag>
                </a-descriptions-item>
                <a-descriptions-item :label="$t('处理人')" v-if="model.whetherToSolve==1">{{ model.informant }}</a-descriptions-item>
              </a-descriptions>
              <a-descriptions :title="$t('确认信息')" v-if="(model.status == 1 || model.status == 4) && model.whetherToSolve==2">
                <a-descriptions-item :label="$t('确认人')">{{ model.approverName }}</a-descriptions-item>
                <a-descriptions-item :label="$t('确认描述')">{{ model.reason }}</a-descriptions-item>
              </a-descriptions>
              <a-descriptions :title="$t('确认信息')" v-if="model.status == 5">
                <a-descriptions-item :label="$t('确认人')">{{ model.approverName }}</a-descriptions-item>
                <a-descriptions-item :label="$t('是否开启工单')">{{ $t('是') }}</a-descriptions-item>
              </a-descriptions>
              <template v-if="(model.status == 1 || model.status == 4) && model.whetherToSolve==2">
                <a-descriptions :title="$t('处理信息')">
                  <a-descriptions-item :label="$t('处理人')">{{ model.userName }}</a-descriptions-item>
                  <a-descriptions-item :label="$t('处理时间')">{{ model.ticketsDeadline }}</a-descriptions-item>
                </a-descriptions>
                <a-descriptions :column="1">
                  <a-descriptions-item :label="$t('处理描述')">{{ model.resolvedRemark }}</a-descriptions-item>
                  <a-descriptions-item :label="$t('处理图片')"></a-descriptions-item>
                </a-descriptions>
                <div class="img-list">
                  <div
                    class="img-box"
                    v-for="(item, index) in model.resolvedPicture&&model.resolvedPicture.split(',')"
                    :key="index"
                    @click="viewPicture1(item)"
                  >
                    <div>
                      <img :src="setSrc(item)" alt="" />
                    </div>
                  </div>
                </div>
              </template>
              <a-descriptions :title="$t('处理信息')" v-if="(model.status == 1 || model.status == 4) && model.whetherToSolve==1">
                <a-descriptions-item :label="$t('处理人')">{{ model.informant }}</a-descriptions-item>
                <a-descriptions-item :label="$t('处理时间')">{{ model.createTime }}</a-descriptions-item>
              </a-descriptions>
              <a-descriptions :column="2" :title="$t('驳回信息')" v-if="model.status == 2">
                <a-descriptions-item :label="$t('驳回时间')">{{ model.reasonsForRemarkTime }}</a-descriptions-item>
                <a-descriptions-item :label="$t('驳回原因')">{{ model.reasonsForRemark }}</a-descriptions-item>
              </a-descriptions>
              <a-descriptions :column="2" :title="$t('搁置信息')" v-if="model.status == 3">
                <a-descriptions-item :label="$t('搁置时间')">{{ model.reasonsForTime }}</a-descriptions-item>
                <a-descriptions-item :label="$t('搁置原因')">{{ model.reasonsForShelving }}</a-descriptions-item>
              </a-descriptions>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
    <j-modal
      :title="$t('预览')"
      :body-style="{ height: '480px' }"
      :visible="visiblePirture"
      :maskClosable="false"
      @cancel="visiblePirture = false"
      :okButtonProps="{ class: { 'jee-hidden': true } }"
    >
      <img :src="viewUrl" alt="" style="width: 100%; height: 100%" />
    </j-modal>
  </j-modal>
</template>
    
    <script>
import { httpAction, getAction } from '@/api/manage'
import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
export default {
  name: 'modal',
  components: {},
  data() {
    return {
      title: this.$t('详情'),
      width: 800,
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      url: {
        workOrderDetails: '/jeecg-engineering/InspectionWorkOrderController/workOrderDetails',
      },
      model: {},
      validatorRules: {},
      filterDictTextByCache: filterDictTextByCache,
      visiblePirture: false,
      viewUrl: '',
    }
  },
  methods: {
    init(row) {
      this.visible = true
      this.disableSubmit = true
      getAction(this.url.workOrderDetails, { id: row.id }).then((res) => {
        if (res.success) {
          this.model = res.result
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    handleOk() {},

    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
    viewPicture(item) {
      if (item.fileType == 'image') {
        this.visiblePirture = true
        this.viewUrl = item.url
      }
    },
    viewPicture1(item) {
      this.visiblePirture = true
      this.viewUrl = window._CONFIG['domianURL']+'/sys/common/static/'+ item
    },
    setSrc(item){
      return window._CONFIG['domianURL']+'/sys/common/static/'+ item
    }
  },
}
</script>
<style lang="less" scoped>
.img-list {
  display: flex;
  .img-box {
    width: 150px;
    height: 150px;
    margin: 5px;
    cursor: pointer;
    border-radius: 4px;
    div{
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
      video {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
    }
  }
}
</style>